import {Button} from '@wandb/weave/components';
import React from 'react';

export const SettingTitle: React.FC<{
  title: string;
  id?: string;
  description?: string;
  tooltip?: string;
}> = ({title, id, description, tooltip}) => {
  return (
    <div className="flex flex-col">
      <div className="flex gap-4" id={id}>
        <div className="pb-2 font-semibold">{title}</div>
        {tooltip && (
          <Button
            size="small"
            variant="ghost"
            icon="info"
            tooltipProps={{className: 'w-[20rem]'}}
            tooltip={tooltip}
          />
        )}
      </div>
      {description && (
        <div className="pt-2 text-sm text-moon-600">{description}</div>
      )}
    </div>
  );
};
